import locales, { Locale } from './localization';

export function getTextLocalization(locale: Locale) {
  return {
    ...locales[locale],
  };
}
